import React, { useEffect } from "react";
import "../styles/blogSection.css";
import BreadCrumb from "../components/BreadCrumb";
import { useNavigate } from "react-router-dom";
import Meta from "../components/Meta";
import { getAllBlogs } from "../features/blogs/blogSlice";
import { useDispatch, useSelector } from "react-redux";

const Blogs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { blog: blogs = [], isLoading } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(getAllBlogs());
  }, [dispatch]);

  const handleReadMore = (slug) => {
    navigate(`/blogs/${slug}`);
  };

  return (
    <>
    <Meta
  title="Matel Trading Motors | Blogs"
  description="Read the latest automotive blogs from Matel Trading Motors. Stay updated on car import tips, vehicle maintenance guides, and industry insights."
  keywords="Matel Trading Motors blogs, car import blogs Kenya, automotive tips, car buying guides, vehicle articles Kenya"
  canonical="https://mateltradingmotors.com/blogs"
/>

      <BreadCrumb title="Blogs" />

      <div className="blog-section blogs-wrapper">
        <div className="blog-card-grid">
          {/* Skeleton loader */}
          {isLoading && (
            <>
              <div className="blog-card skeleton"></div>
              <div className="blog-card skeleton"></div>
              <div className="blog-card skeleton"></div>
            </>
          )}

          {/* Dynamic Blog Data */}
          {!isLoading &&
            blogs.map((blog, index) => {
              // Extract plain text from HTML description
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = blog.description;
              const plainText =
                tempDiv.textContent || tempDiv.innerText || "";
              const snippet = plainText.substring(0, 100) + "...";

              const formattedDate = new Date(blog.createdAt).toLocaleDateString(
                "en-US",
                {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                }
              );

              return (
                <div className="blog-card" key={index}>
                  <img
                    src={blog.images?.[0]?.url}
                    alt={blog.title}
                    title={blog.title}
                  />

                  <div className="blog-content">
                    <h4 onClick={() => handleReadMore(blog.slug)}>
                      {blog.title}
                    </h4>

                    <p className="blog-date">{formattedDate}</p>

                    <p className="blog-description">{snippet}</p>

                    <a
                      onClick={() => handleReadMore(blog.slug)}
                      className="read-more"
                    >
                      READ MORE →
                    </a>
                  </div>
                </div>
              );
            })}

          {/* No blogs */}
          {!isLoading && blogs.length === 0 && (
            <p className="no-blogs">No blogs available right now.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default Blogs;
